import request from '@/utils/request'

export function findAssessors(branchId, find) {
  return request({
    url: `/msma/users/assessor/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function findProjectLeaders(branchId, find) {
  return request({
    url: `/msma/users/projectleader/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/msmaUsers.js